module.exports = {"pt-BR":{"components":{"internal-server-error":{"message":"Alguma coisa saiu errado! Espere alguns segundos para tentar novamente."}}}}